import React from 'react';
import ReactDOM from 'react-dom';

import './styles/main.css';
import './styles/reset.min.css';

import App from './App';
import * as serviceWorker from './serviceWorker';

import { ListProvider } from './store';

ReactDOM.render(
  <React.StrictMode>
    <ListProvider>
      <App />
    </ListProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
